import type { FieldErrors } from '../api/errors';
import { systemFieldRequirement } from '../domain/validation';
import { selectHeading, selectParagraph, shouldShowError } from '../state/selectors';
import { useEnv, useFormState } from './context';
import { TextField } from './fields/inputs';
import { Section } from './Section';

interface Props {
  errors: FieldErrors;
}

export function DiscountCode({ errors }: Props) {
  const { controller } = useEnv();
  const state = useFormState();
  const field = systemFieldRequirement(state.bootstrap?.form ?? null, 'discount_code', { requireZip: false });
  if (!field.shown) return null;
  const applyLabel = state.bootstrap?.form.settings?.apply_button?.button_text?.trim() || 'Apply';
  const show = shouldShowError(state, 'discount_code', 2) ? Array.from(new Set([...(errors['discount_code'] ?? []), ...(state.apiErrors['discount_code'] ?? [])])) : [];
  const est = state.estimate.data;
  const applied = state.values.appliedDiscountCode && est && ((est.price_for_discount_by_code ?? 0) > 0 || (est.giftcard_amount ?? 0) > 0);

  return (
    <Section heading={selectHeading(state, 'discount_code_section')} paragraph={selectParagraph(state, 'discount_code_information')}>
      <form
        style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}
        onSubmit={(e) => {
          e.preventDefault();
          controller.send({ type: 'DISCOUNT_CODE_APPLIED' });
        }}
      >
        <div style={{ flex: '1 1 240px' }}>
          <TextField fieldKey="discount_code" label={field.label} errors={show} value={state.values.discountCode} onChange={(v) => controller.send({ type: 'DISCOUNT_CODE_CHANGED', code: v })} onBlur={() => controller.send({ type: 'FIELD_BLURRED', key: 'discount_code' })} autoComplete="off" help={applied ? `Code ${state.values.appliedDiscountCode} applied.` : null} />
        </div>
        <button type="submit" className="cbf-btn cbf-btn-secondary" disabled={!state.values.discountCode.trim()}>
          {applyLabel}
        </button>
      </form>
    </Section>
  );
}
